<div class="theme-toggle" [matTooltip]="tooltipKey() | translate">
  <mat-icon fontSet="material-symbols-outlined" class="theme-toggle__icon" aria-hidden="true">light_mode</mat-icon>
  <mat-slide-toggle
    class="theme-toggle__switch"
    color="primary"
    [checked]="isDark()"
    (change)="onToggleChange()"
    [attr.aria-label]="'theme-toggle.label' | translate"></mat-slide-toggle>
  <mat-icon fontSet="material-symbols-outlined" class="theme-toggle__icon" aria-hidden="true">dark_mode</mat-icon>
</div>
